import React, { useEffect, useState } from "react";
import axios from "axios";
import Form from "./Form"; // Adjust the import path as necessary
import { toast } from "react-hot-toast";

const API_BASE_URL = process.env.REACT_APP_BASE_URI;

const Questions = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/question`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setQuestions(res.data.filter((question: any) => !question.isRemoved));
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch questions");
    } finally {
      setLoading(false);
    }
  };

  const deleteQuestion = async (id: any) => {
    try {
      await axios.delete(`${API_BASE_URL}/question/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      fetchQuestions();
      toast.success("Question deleted successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete question");
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">
          Online Test Questions
        </h1>
        <button
          onClick={() => setIsDialogOpen(true)}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
        >
          Add Question
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {questions.map((question: any, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg overflow-hidden"
            >
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-semibold text-gray-800">
                    {question.title}
                  </h2>
                  {question.questionType === 'image' && (
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                      Image Question
                    </span>
                  )}
                </div>
                
                {question.questionType === 'image' && question.imageUrl && (
                  <div className="mb-4">
                    <img 
                      src={question.imageUrl} 
                      alt="Question" 
                      className="w-full h-32 object-cover rounded-lg"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Display Duration: {question.imageDisplayDuration || 30}s
                    </p>
                  </div>
                )}
                
                <div className="space-y-2 mb-4">
                  {question.options.map((option: any, optionIndex: any) => (
                    <p
                      key={optionIndex}
                      className={`p-2 rounded ${
                        question.answer === optionIndex
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-100 text-gray-700"
                      }`}
                    >
                      {option}
                    </p>
                  ))}
                </div>
                <button
                  onClick={() => deleteQuestion(question._id)}
                  className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && questions.length === 0 && (
        <p className="text-gray-600 text-center py-8">No questions found</p>
      )}

      {isDialogOpen && (
        <Form
          fetchquestions={fetchQuestions}
          closeDialog={() => setIsDialogOpen(false)}
        />
      )}
    </div>
  );
};

export default Questions;
